// extracted by mini-css-extract-plugin
export default {"button":"styles_button__oI8kS","icon":"styles_icon__vxJW-"};